import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IndxpProcessorService } from 'src/app/services/indxp-processor.service';
import { v4 as uuidv4 } from 'uuid';

@Component({ standalone: false,
  selector: 'app-form-processor-benefit',
  templateUrl: './form-processor-benefit.component.html',
  styleUrls: ['./form-processor-benefit.component.css']
})
export class FormProcessorBenefitComponent {

  myForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private indxpProcessor: IndxpProcessorService,
  ) {
    var buyOrder = '' + (new Date().getTime());;
    this.myForm = this.formBuilder.group({
      'token': ['XXX-1234-55555555-6666-7777-8888-99999999999999'],
      'buyOrder': [buyOrder],
      'identifier1': [uuidv4()],
      'identifier2': [uuidv4()],
      'identifier3': [uuidv4()],
      'identifier4': [uuidv4()],
      'identifier5': [uuidv4()],
      'merchantCode': ['20304050600'],
      'merchantName': ['Comercio con RUC 20304050600'],
      'documentType': ['DNI'],
      'documentNumber': ['55770001'],
      'cardId': ['491337******9997'],
      'rewardPoints': [0],
      'redeemedRewardPoints': [0],
      'exchangeRate': [0.210000],
      'verificationCode': [''],
      'refundedRewardPoints': [0],
      'authorizationCode': [''],
      'partialRefundedRewardPoints': [0],
      'result1': [''],
      'result2': [''],
      'result3': [''],
      'result4': [''],
      'result5': [''],
    });
  }

  changeDocumentType(event: any) {
    console.log('change documentType', event);
  }

  consultarMillas() {
    var request = {
      "commerce": {
        "code": "12351",
        "category": "5411",
        "name": "NORMAC"
      },
      "store": {
        "token": "c8d23d68b3a6ac115d51694a3c15a79de9baf85d71ac15",
        "ruc": this.myForm.get('merchantCode')?.value,
        "name": this.myForm.get('merchantName')?.value,
        "address": "Lima",
        "channel": 88,
        "izipayCode": 4076797,
        "agoraWebCode": 5100,
        "cybersourceCode": 4076941,
        "dutyFree": false
      },
      "payer": {
        "userId": "df3bf066-8a99-466a-a788-981e2302e060",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": this.myForm.get('documentType')?.value,
        "document": this.myForm.get('documentNumber')?.value,
        "phone": "964207810",
        "street": "Paseo la Castellana",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "buyer": {
        "userId": "PLV-96-f9087a45-e7f1-4d11-9bdd-fc293dd8261blnO1",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": "DNI",
        "document": "df3bf066-8a99-466a-a788-981e2302e060",
        "phone": "+51987987987",
        "street": "PASEO LA CASTELLANA",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "token": this.myForm.get('token')?.value,
      "buyOrder": this.myForm.get('buyOrder')?.value,
      "externalReference": "",
      "type": "App Agora Pay",
      "currency": "PEN",
      "totalAmount": 40.41,
      "lang": "es_PE",
      "channel": "WEB|MOB",
      "additionalData": {
        "name1": "value1",
        "name2": "value2"
      },
      "clientRequest": {
        "userAgent": "shop-ios/1 CFNetwork/1390 Darwin/21.6.0",
        "remoteAddress": "172.31.40.136",
        "remoteHost": "172.31.40.136",
        "requestTrace": "092356db-9ef5-48ed-8fb4-1159d147cdd0",
        "forwardedFor": "190.236.205.127",
        "requestDate": "2022-09-26T16:09:11.968+0000",
        "browserParameters": {
          "timeZoneOffset": "300",
          "deviceType": "MOBILE",
          "language": "es-US",
          "screenWidth": "320",
          "javaEnabled": "false",
          "screenHeight": "500",
          "colorDepth": "24"
        }
      },
      "details": [
        {
          "id": 18769,
          "sku": "171",
          "quantity": 1,
          "name": "Lavadora SAMSUNG Carga Superior 17Kg WA17F7L2UDY/PE Plateado",
          "category": "750",
          "amount": 30.0,
          "discount": 0.0,
          "shipping": 0.0
        }
      ],
      "actionData": {
        "process": "CUSTOM_ACTION",
        "subProcess": "CHECK_REWARDS",
        "identifier": this.myForm.get('identifier1')?.value,
        "acquirer": "BENEFIT",
        "acquirerCode": 'BENEFIT',
        "serviceName": "BENEFIT",
        "serviceCode": "BENEFIT",
        "serviceProcessingIdentifier": "identifier(sequence)-in-service-code",
        "amount": 0,
        "additionalData": {
          "cardId": this.myForm.get('cardId')?.value,
        }
      }
    }

    this.indxpProcessor.process(request).subscribe(response => {
      console.log('response', JSON.stringify(response));
      // console.log('['+response.result.processor.additionalData['rewards.points']+']')
      this.myForm.get('result1')?.setValue(response.result.code);
      this.myForm.get('rewardPoints')?.setValue(response.result.processor.additionalData['rewards.points']);
    });


  }

  solicitarEnvioOTP() {
    var request = {
      "commerce": {
        "code": "12351",
        "category": "5411",
        "name": "NORMAC"
      },
      "store": {
        "token": "c8d23d68b3a6ac115d51694a3c15a79de9baf85d71ac15",
        "ruc": this.myForm.get('merchantCode')?.value,
        "name": this.myForm.get('merchantName')?.value,
        "address": "Lima",
        "channel": 88,
        "izipayCode": 4076797,
        "agoraWebCode": 5100,
        "cybersourceCode": 4076941,
        "dutyFree": false
      },
      "payer": {
        "userId": "df3bf066-8a99-466a-a788-981e2302e060",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": this.myForm.get('documentType')?.value,
        "document": this.myForm.get('documentNumber')?.value,
        "phone": "964207810",
        "street": "Paseo la Castellana",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "buyer": {
        "userId": "PLV-96-f9087a45-e7f1-4d11-9bdd-fc293dd8261blnO1",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": "DNI",
        "document": "df3bf066-8a99-466a-a788-981e2302e060",
        "phone": "+51987987987",
        "street": "PASEO LA CASTELLANA",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "token": this.myForm.get('token')?.value,
      "buyOrder": this.myForm.get('buyOrder')?.value,
      "externalReference": "",
      "type": "App Agora Pay",
      "currency": "PEN",
      "totalAmount": 40.41,
      "lang": "es_PE",
      "channel": "WEB|MOB",
      "additionalData": {
        "name1": "value1",
        "name2": "value2"
      },
      "clientRequest": {
        "userAgent": "shop-ios/1 CFNetwork/1390 Darwin/21.6.0",
        "remoteAddress": "172.31.40.136",
        "remoteHost": "172.31.40.136",
        "requestTrace": "092356db-9ef5-48ed-8fb4-1159d147cdd0",
        "forwardedFor": "190.236.205.127",
        "requestDate": "2022-09-26T16:09:11.968+0000",
        "browserParameters": {
          "timeZoneOffset": "300",
          "deviceType": "MOBILE",
          "language": "es-US",
          "screenWidth": "320",
          "javaEnabled": "false",
          "screenHeight": "500",
          "colorDepth": "24"
        }
      },
      "details": [
        {
          "id": 18769,
          "sku": "171",
          "quantity": 1,
          "name": "Lavadora SAMSUNG Carga Superior 17Kg WA17F7L2UDY/PE Plateado",
          "category": "750",
          "amount": 30.0,
          "discount": 0.0,
          "shipping": 0.0
        }
      ],
      "actionData": {
        "process": "CUSTOM_ACTION",
        "subProcess": "GENERATE_OTP",
        "identifier": this.myForm.get('identifier2')?.value,
        "acquirer": "BENEFIT",
        "acquirerCode": 'BENEFIT',
        "serviceName": "BENEFIT",
        "serviceCode": "BENEFIT",
        "serviceProcessingIdentifier": "identifier(sequence)-in-service-code",
        "amount": 0,
        "additionalData": {
          "cardId": this.myForm.get('cardId')?.value
        }
      }
    }

    this.indxpProcessor.process(request).subscribe(response => {
      console.log('response', JSON.stringify(response));
      // console.log('['+response.result.processor.additionalData['rewards.points']+']')
      this.myForm.get('result2')?.setValue(response.result.code);
    });

  }

  autorizarCanje() {

    var request = {
      "commerce": {
        "code": "12351",
        "category": "5411",
        "name": "NORMAC"
      },
      "store": {
        "token": "c8d23d68b3a6ac115d51694a3c15a79de9baf85d71ac15",
        "ruc": this.myForm.get('merchantCode')?.value,
        "name": this.myForm.get('merchantName')?.value,
        "address": "Lima",
        "channel": 88,
        "izipayCode": 4076797,
        "agoraWebCode": 5100,
        "cybersourceCode": 4076941,
        "dutyFree": false
      },
      "payer": {
        "userId": "df3bf066-8a99-466a-a788-981e2302e060",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": this.myForm.get('documentType')?.value,
        "document": this.myForm.get('documentNumber')?.value,
        "phone": "964207810",
        "street": "Paseo la Castellana",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "buyer": {
        "userId": "PLV-96-f9087a45-e7f1-4d11-9bdd-fc293dd8261blnO1",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": "DNI",
        "document": "df3bf066-8a99-466a-a788-981e2302e060",
        "phone": "+51987987987",
        "street": "PASEO LA CASTELLANA",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "token": this.myForm.get('token')?.value,
      "buyOrder": this.myForm.get('buyOrder')?.value,
      "externalReference": "",
      "type": "App Agora Pay",
      "currency": "PEN",
      "totalAmount": 40.41,
      "lang": "es_PE",
      "channel": "WEB|MOB",
      "additionalData": {
        "name1": "value1",
        "name2": "value2"
      },
      "clientRequest": {
        "userAgent": "shop-ios/1 CFNetwork/1390 Darwin/21.6.0",
        "remoteAddress": "172.31.40.136",
        "remoteHost": "172.31.40.136",
        "requestTrace": "092356db-9ef5-48ed-8fb4-1159d147cdd0",
        "forwardedFor": "190.236.205.127",
        "requestDate": "2022-09-26T16:09:11.968+0000",
        "browserParameters": {
          "timeZoneOffset": "300",
          "deviceType": "MOBILE",
          "language": "es-US",
          "screenWidth": "320",
          "javaEnabled": "false",
          "screenHeight": "500",
          "colorDepth": "24"
        }
      },
      "details": [
        {
          "id": 18769,
          "sku": "171",
          "quantity": 1,
          "name": "Lavadora SAMSUNG Carga Superior 17Kg WA17F7L2UDY/PE Plateado",
          "category": "750",
          "amount": 30.0,
          "discount": 0.0,
          "shipping": 0.0
        }
      ],
      "actionData": {
        "process": "AUTHORIZE",
        "identifier": this.myForm.get('identifier3')?.value,
        "acquirer": "BENEFIT",
        "acquirerCode": 'BENEFIT',
        "serviceName": "BENEFIT",
        "serviceCode": "BENEFIT",
        "serviceProcessingIdentifier": "identifier(sequence)-in-service-code",
        "amount": 0,
        "additionalData": {
          "cardId": this.myForm.get('cardId')?.value,
          "totalMiles": this.myForm.get('redeemedRewardPoints')?.value,
          "miles": this.myForm.get('redeemedRewardPoints')?.value,
          "exchangeRate": this.myForm.get('exchangeRate')?.value,
          "validationCode": this.myForm.get('verificationCode')?.value
        }
      }
    }

    this.indxpProcessor.process(request).subscribe(response => {
      console.log('response', JSON.stringify(response));
      // console.log('['+response.result.processor.additionalData['rewards.points']+']')
      this.myForm.get('result3')?.setValue(response.result.code);
      this.myForm.get('authorizationCode')?.setValue(response.result.processor.additionalData['authorization.code']);
    });

  }

  anularCanje() {

    var request = {
      "commerce": {
        "code": "12351",
        "category": "5411",
        "name": "NORMAC"
      },
      "store": {
        "token": "c8d23d68b3a6ac115d51694a3c15a79de9baf85d71ac15",
        "ruc": this.myForm.get('merchantCode')?.value,
        "name": this.myForm.get('merchantName')?.value,
        "address": "Lima",
        "channel": 88,
        "izipayCode": 4076797,
        "agoraWebCode": 5100,
        "cybersourceCode": 4076941,
        "dutyFree": false
      },
      "payer": {
        "userId": "df3bf066-8a99-466a-a788-981e2302e060",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": this.myForm.get('documentType')?.value,
        "document": this.myForm.get('documentNumber')?.value,
        "phone": "964207810",
        "street": "Paseo la Castellana",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "buyer": {
        "userId": "PLV-96-f9087a45-e7f1-4d11-9bdd-fc293dd8261blnO1",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": "DNI",
        "document": "df3bf066-8a99-466a-a788-981e2302e060",
        "phone": "+51987987987",
        "street": "PASEO LA CASTELLANA",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "token": this.myForm.get('token')?.value,
      "buyOrder": this.myForm.get('buyOrder')?.value,
      "externalReference": "",
      "type": "App Agora Pay",
      "currency": "PEN",
      "totalAmount": 40.41,
      "lang": "es_PE",
      "channel": "WEB|MOB",
      "additionalData": {
        "name1": "value1",
        "name2": "value2"
      },
      "clientRequest": {
        "userAgent": "shop-ios/1 CFNetwork/1390 Darwin/21.6.0",
        "remoteAddress": "172.31.40.136",
        "remoteHost": "172.31.40.136",
        "requestTrace": "092356db-9ef5-48ed-8fb4-1159d147cdd0",
        "forwardedFor": "190.236.205.127",
        "requestDate": "2022-09-26T16:09:11.968+0000",
        "browserParameters": {
          "timeZoneOffset": "300",
          "deviceType": "MOBILE",
          "language": "es-US",
          "screenWidth": "320",
          "javaEnabled": "false",
          "screenHeight": "500",
          "colorDepth": "24"
        }
      },
      "details": [
        {
          "id": 18769,
          "sku": "171",
          "quantity": 1,
          "name": "Lavadora SAMSUNG Carga Superior 17Kg WA17F7L2UDY/PE Plateado",
          "category": "750",
          "amount": 30.0,
          "discount": 0.0,
          "shipping": 0.0
        }
      ],
      "actionData": {
        "process": "REVERSE",
        "identifier": this.myForm.get('identifier4')?.value,
        "acquirer": "BENEFIT",
        "acquirerCode": 'BENEFIT',
        "serviceName": "BENEFIT",
        "serviceCode": "BENEFIT",
        "serviceProcessingIdentifier": "identifier(sequence)-in-service-code",
        "amount": 0,
        "additionalData": {
          "cardId": this.myForm.get('cardId')?.value,
          "totalMiles": this.myForm.get('refundedRewardPoints')?.value,
          "miles": this.myForm.get('refundedRewardPoints')?.value,
          "exchangeRate": this.myForm.get('exchangeRate')?.value,
          "authorizationCode": this.myForm.get('authorizationCode')?.value
        }
      }
    }

    this.indxpProcessor.process(request).subscribe(response => {
      console.log('response', JSON.stringify(response));
      // console.log('['+response.result.processor.additionalData['rewards.points']+']')
      this.myForm.get('result4')?.setValue(response.result.code);
    });

  }

  devolverCanje() {

    var request = {
      "commerce": {
        "code": "12351",
        "category": "5411",
        "name": "NORMAC"
      },
      "store": {
        "token": "c8d23d68b3a6ac115d51694a3c15a79de9baf85d71ac15",
        "ruc": this.myForm.get('merchantCode')?.value,
        "name": this.myForm.get('merchantName')?.value,
        "address": "Lima",
        "channel": 88,
        "izipayCode": 4076797,
        "agoraWebCode": 5100,
        "cybersourceCode": 4076941,
        "dutyFree": false
      },
      "payer": {
        "userId": "df3bf066-8a99-466a-a788-981e2302e060",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": this.myForm.get('documentType')?.value,
        "document": this.myForm.get('documentNumber')?.value,
        "phone": "964207810",
        "street": "Paseo la Castellana",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "buyer": {
        "userId": "PLV-96-f9087a45-e7f1-4d11-9bdd-fc293dd8261blnO1",
        "firstName": "prueba",
        "lastName": "prueba",
        "email": "prueba@prueba.com",
        "documentType": "DNI",
        "document": "df3bf066-8a99-466a-a788-981e2302e060",
        "phone": "+51987987987",
        "street": "PASEO LA CASTELLANA",
        "city": "LIMA",
        "state": "LIMA",
        "country": "PER",
        "postalCode": "150140"
      },
      "token": this.myForm.get('token')?.value,
      "buyOrder": this.myForm.get('buyOrder')?.value,
      "externalReference": "",
      "type": "App Agora Pay",
      "currency": "PEN",
      "totalAmount": 40.41,
      "lang": "es_PE",
      "channel": "WEB|MOB",
      "additionalData": {
        "name1": "value1",
        "name2": "value2"
      },
      "clientRequest": {
        "userAgent": "shop-ios/1 CFNetwork/1390 Darwin/21.6.0",
        "remoteAddress": "172.31.40.136",
        "remoteHost": "172.31.40.136",
        "requestTrace": "092356db-9ef5-48ed-8fb4-1159d147cdd0",
        "forwardedFor": "190.236.205.127",
        "requestDate": "2022-09-26T16:09:11.968+0000",
        "browserParameters": {
          "timeZoneOffset": "300",
          "deviceType": "MOBILE",
          "language": "es-US",
          "screenWidth": "320",
          "javaEnabled": "false",
          "screenHeight": "500",
          "colorDepth": "24"
        }
      },
      "details": [
        {
          "id": 18769,
          "sku": "171",
          "quantity": 1,
          "name": "Lavadora SAMSUNG Carga Superior 17Kg WA17F7L2UDY/PE Plateado",
          "category": "750",
          "amount": 30.0,
          "discount": 0.0,
          "shipping": 0.0
        }
      ],
      "actionData": {
        "process": "REFUND",
        "identifier": this.myForm.get('identifier4')?.value,
        "acquirer": "BENEFIT",
        "acquirerCode": 'BENEFIT',
        "serviceName": "BENEFIT",
        "serviceCode": "BENEFIT",
        "serviceProcessingIdentifier": "identifier(sequence)-in-service-code",
        "amount": 0,
        "additionalData": {
          "cardId": this.myForm.get('cardId')?.value,
          "totalMiles": this.myForm.get('partialRefundedRewardPoints')?.value,
          "miles": this.myForm.get('partialRefundedRewardPoints')?.value,
          "exchangeRate": this.myForm.get('exchangeRate')?.value
        }
      }
    }

    this.indxpProcessor.process(request).subscribe(response => {
      console.log('response', JSON.stringify(response));
      // console.log('['+response.result.processor.additionalData['rewards.points']+']')
      this.myForm.get('result5')?.setValue(response.result.code);
    });

  }
}
